import { map, compact } from 'lodash';
import { DateUtils } from './DateUtils';

const getHash = () => {
    const routeStripper = /^[#/]|\s+$/g;
    const match = window.location.href.match(/#(.*)$/);
    const hash = match ? match[1] : null;
    return hash && hash.replace(routeStripper, '');
};

const extractHomeParameters = () => {
    const fragment = getHash();
    const homeRoute = new RegExp(
        /^\/?(?:(?:frontend-home\/(?:flights\/|dp\/))?home\/(.*)|frontend-home\/(?:flights\/|dp\/)?|\/?)$/,
    );
    const fragmentMatch = homeRoute.exec(fragment);
    const params = fragmentMatch ? fragmentMatch.slice(1) : null;
    return map(params, function(param, i) {
        // Don't decode the search params.
        if (i === params.length - 1) {
            return param || null;
        }
        return param ? decodeURIComponent(param) : null;
    });
};

const parseHashParameters = (hashParameters) => {
    let splitHash = new RegExp(/(?:;|%3B)/gi);
    let separatorHash = '=';
    let separatorPath = '/';

    return compact(hashParameters.trimLeft(separatorPath).split(splitHash)).reduce(
        (memo, params) => {
            const hash = params.split(separatorHash);
            memo[hash[0]] = hash[1];
            return memo;
        },
        {},
    );
};

const checkDates = (params) => {
    Object.keys(params).forEach((key) => {
        const re = new RegExp('^(dep|ret)(\\d+)?$');
        if (
            key.match(re) &&
            (!DateUtils.isNotExpired(params[key]) || DateUtils.isOutOfBounds(params[key]))
        ) {
            delete params[key];
        }
    });
    return params;
};

export const doRequest = (url, options = {}) => {
    const defaultOptions = {
        credentials: 'include',
    };
    return fetch(url, Object.assign({}, defaultOptions, options));
};

export const URLUtils = {
    getHomeHashParams() {
        const params = extractHomeParameters();
        let validatedParams = null;
        if (params.length) {
            const parsedParams = parseHashParameters(decodeURI(params));
            validatedParams = checkDates(parsedParams);
        }
        return validatedParams;
    },
    getHomeUrlParams(params, page = 'home') {
        const url = Object.keys(params).reduce((result, key) => {
            return result.concat(`${key}=${params[key]};`);
        }, '');
        return url !== '' ? `#${page}/${url}` : '';
    },
    getQueryParam(param) {
        return new URL(window.location.href)?.searchParams?.get(param);
    },
    getSearch() {
        return window.location.href ? new URL(window.location.href)?.search : '';
    },
};

/**
 * 'k1=v1&k2=v2' => { k1: 'v1', k2: 'v2' }
 * @param {string} query
 * @param {string} separator Defautls to &
 * @return {object} the parsed query
 */
export const queryString = (query, separator = '&') => {
    const equals = '=';
    return query
        .split(separator)
        .filter((cookie) => !!cookie)
        .map((cookie) => cookie.split(equals))
        .reduce((acc, item) => ({ ...acc, [item.shift().trim()]: item.join(equals) }), {});
};

const setParam = (url, key, value) => {
    const name = key.replace(/[[]]/g, '\\$&');
    const regex = new RegExp('([?&]' + name + ')(=([^&#]*)|&|#|$)');
    if (regex.test(url)) {
        return url.replace(regex, '$1=' + encodeURIComponent(value));
    }
    const union = /\?/.test(url) ? '&' : '?';
    return url + union + name + '=' + value;
};

export const setParams = (url, params) => {
    return Object.entries(params).reduce((acc, [key, value]) => setParam(acc, key, value), url);
};

const getEditPageSlug = () => {
    const editPageSlug = 'flights/edit/';
    return window.location.hash.indexOf(editPageSlug) > -1 ? editPageSlug : '';
};
export const getHashId = () => window.location.hash.slice(1).toUpperCase();
export const pushBrowserHistory = (id) => {
    const value = getEditPageSlug();
    window.history.pushState({}, id, `#${value}${id.toLowerCase()}`);
};

export const resetHash = () => {
    const value = getEditPageSlug();
    window.location.replace(`#${value}`);
};

export const getDeeplinkURL = ({ path, fragment }, params) => {
    const { host, protocol } = window.location;
    return `${protocol}//${host}${path}/#${fragment}/${params}`;
};

export const getMFEDeeplinkURL = ({ path, fragment }, params) => {
    const { host, protocol } = window.location;
    return `${protocol}//${host}${path}/${fragment}/${params}`;
};

export const getDeeplinkQueryURL = ({ path, fragment, queryParam }, params) => {
    const { host, protocol } = window.location;
    return `${protocol}//${host}${path}/?${queryParam}=${fragment}/${params}`;
};

export const getDeeplinkSearchURL = ({ path, fragment, search }, params) => {
    const { host, protocol } = window.location;
    return `${protocol}//${host}${path}/${search}/#${fragment}/${params}`;
};
